import { Box, CircularProgress } from '@mui/material'
import { LoaderType, LoaderProps } from './types'

export function Loader({
  heightValue = 0,
  type = LoaderType.RELATIVE
}: LoaderProps) {
  if (type === LoaderType.ABSOLUTE) {
    return (
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <CircularProgress />
      </Box>
    )
  }
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: !!heightValue ? `${heightValue}px` : 'auto'
      }}
    >
      <CircularProgress />
    </Box>
  )
}
